// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_vc";
export var lbContainerInner = "B_vd";
export var movingForwards = "B_vf";
export var movingForwardsOther = "B_vg";
export var movingBackwards = "B_vh";
export var movingBackwardsOther = "B_vj";
export var lbImage = "B_vk";
export var lbOtherImage = "B_vl";
export var prevButton = "B_vm";
export var nextButton = "B_vn";
export var closing = "B_vp";
export var appear = "B_vq";